<template>
    <div>
<!--hero section start-->

<section class="banner fullscreen-banner o-hidden gradient-bg p-0">
  <div class="banner-bg" data-bg-img="images/bg/02.jpg" data-overlay="6"></div>
  <div class="align-center b-pl">
    <div class="container">
      <div class="row">
        <div class="col-lg-7">
          <h6 class="text-uppercase letter-space-2 text-white">We Provide Outsourced</h6>
          <h1 class="text-white mb-3"><span class="font-w-4">We Build A</span> Amazing Design</h1>
          <p class="mb-4 text-light">We created a experienced a surge in popularity during the 1960s when<br> Letraset used it on their dry-transfer sheets</p>
          <a class="btn btn-white" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
        </div>
      </div>
    </div>
  </div>
  <div class="hero-left bg-transparent h-100 d-flex align-items-center justify-content-center">
    <div class="hero-social text-center">
      <ul class="list-unstyled">
        <li><a href="#"> <i class="fab fa-facebook-f"></i></a></li>
        <li><a href="#"> <i class="fab fa-dribbble"></i></a></li>
        <li><a href="#"> <i class="fab fa-skype"></i></a></li>
        <li><a href="#"> <i class="fab fa-linkedin-in"></i></a></li>
      </ul>
  </div>
  <a href="#main-page" class="scroll-down-arrow"></a>
  </div>
</section>

<!--hero section end-->
<!--body content start-->

<div id="main-page" class="page-content">

<!--about start-->

<section class="pb-0 z-index-1 pos-r o-hidden">
 <div class="inside-text">
    <span>About</span>
  </div>
  <div class="container">
     <div class="row justify-content-center text-center">
      <div class="col-md-10">
        <h4 class="text-black font-w-5 line-h-2">Agencio far away behind the word mountains <span class="text-theme">Agency</span> like you. With useful features an interface and <span class="text-theme">powerful Design</span> built by a community of developers, there live the blind texts.</h4>
      </div>
    </div>
    <div class="row mt-5">      
      <div class="col-lg-6 col-12 ml-auto pr-lg-5 order-lg-1">
        <div class="section-title mb-4">
          <h6>About US</h6>
          <h2 class="title">Agencio Build Branded Design</h2>          
        </div>
        <ul class="list-unstyled list-icon">
          <li class="mb-4"> <i class="fas fa-check"></i> Lorem ipsum dolor sit</li>
          <li class="mb-4"> <i class="fas fa-check"></i> Molestias, eum odio dolorem</li>
          <li class="mb-4 mb-sm-0"> <i class="fas fa-check"></i> Eum nihil expedita dolorum </li>
          <li> <i class="fas fa-check"></i> Explicabo perferendis</li>
        </ul>
        <p class="mt-4">Agencio discovering the source behind the ubiquitous filler text In seeing behind, discovering the source behind the ubiquitous filler text In seeing behind</p>
      </div>
      <div class="col-lg-6 col-12 mt-5 mt-lg-0">
        <img class="img-fluid w-100" src="images/about/01.jpg" alt="">
      </div>
    </div>
  </div>
</section>

<!--about end-->


<!--service start-->

<section class="pos-r py-15 z-index-0 o-hidden dark-bg custom-mt-10">
  <div class="inside-text">
    <span>Service</span>
  </div>
  <div class="container">
    <div class="row align-items-end mb-5">
      <div class="col-lg-6 col-12">
        <div class="section-title mb-0">
          <h6>What We Offer</h6>
          <h2 class="title mb-0">Building Brands More Quickly</h2>
        </div>
      </div>
      <div class="col-lg-6 col-12 md-mt-5">
        <p class="lead text-light font-w-5 mb-0">Agencio discovering the source behind the ubiquitous filler text In seeing a sample of lorem ipsum, his interest was piqued by consectetur Agencio discovering</p>
      </div>
    </div>
  </div>
</section>

<section class="custom-mt-10 pt-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="owl-carousel" data-items="3" data-md-items="2" data-sm-items="1" data-autoplay="true">
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-domain"></i>
              </div>
              <div class="featured-title">
                <h5>Web Development</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4 active">
              <div class="featured-icon"> <i class="flaticon-analytics"></i>
              </div>
              <div class="featured-title">
                <h5>Data Analytics</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-challenges"></i>
              </div>
              <div class="featured-title">
                <h5>Strategy</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-ui"></i>
              </div>
              <div class="featured-title">
                <h5>UX Design</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-histogram"></i>
              </div>
              <div class="featured-title">
                <h5>Marketing</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--service end-->


<section class="pt-0 o-hidden pos-r">
  <div class="inside-text">
    <span>F.A.Q.</span>
  </div>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-md-12">
        <div class="section-title">
          <h6>F.A.Q.</h6>
          <h2 class="title mb-0">Faq and Stuff</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-12">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-md-0 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--case study start-->

<section class="theme-bg pos-r o-hidden" data-bg-img="images/pattern/01.png">
  <div class="inside-text">
    <span>Case Studies</span>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Our Work</h6>
          <h2 class="title mb-0">Explore some of our latest Case Study.</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 col-lg-4">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/05.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Design</span>
              <h3><a href="case-studies-single.html">Experience for Agency</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5 mt-md-0">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/06.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>UX/UI Design</span>
              <h3><a href="case-studies-single.html">Crafted with Love</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5 mt-lg-0">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/07.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Branding</span>
              <h3><a href="case-studies-single.html">Colibri Identity</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/08.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Design</span>
              <h3><a href="case-studies-single.html">Experience for Agency</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/09.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>UX/UI Design</span>
              <h3><a href="case-studies-single.html">Crafted with Love</a></h3>
            </div> 
          </div>
        </div>
      </div>
      <div class="col-md-6 col-lg-4 mt-5">
        <div class="cases-item style-3 js-tilt" data-tilt-perspective="1000" data-tilt-speed="500" data-tilt-max="15">
          <div class="cases-images">
            <img class="img-fluid" src="images/cases/10.jpg" alt="">
          </div>
          <div class="cases-desc">
            <div> <span>Branding</span>
              <h3><a href="case-studies-single.html">Colibri Identity</a></h3>
            </div> 
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--case study end-->


<!--testimonial start-->

<section class="o-hidden pos-r">
  <div class="inside-text">
    <span>Testimonial</span>
  </div>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Testimonial</h6>
          <h2 class="title mb-0">What Client Say?</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="owl-carousel" data-items="1" data-autoplay="true">
          <div class="item">
            <div class="row no-gutters align-items-center">
              <div class="col-md-5">
                <div class="theme-bg text-center p-3 position-absolute z-index-1"><i class="flaticon-left-quote h2 text-white mb-0"></i>
                </div>
                <img class="img-fluid mt-4 ml-md-4 box-shadow" src="images/testimonial/01.jpg" alt="">
              </div>
              <div class="col-md-7 ml-md-n5 mt-n5 mt-md-0">
                <div class="testimonial style-3">
                  <div class="testimonial-content">
                    <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Alvi Miller</h5>
                      <label>Founder of Agencio</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="row no-gutters align-items-center">
              <div class="col-md-5">
                <div class="theme-bg text-center p-3 position-absolute z-index-1"><i class="flaticon-left-quote h2 text-white mb-0"></i>
                </div>
                <img class="img-fluid mt-4 ml-md-4 box-shadow" src="images/testimonial/02.jpg" alt="">
              </div>
              <div class="col-md-7 ml-md-n5 mt-n5 mt-md-0">
                <div class="testimonial style-3">
                  <div class="testimonial-content">
                    <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Albert Jonson</h5>
                      <label>CEO of Agencio</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--testimonial end-->


<!--team start-->

<section class="grey-bg o-hidden pos-r">
  <div class="inside-text">
    <span>Team</span>
  </div>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Expert Team</h6>
          <h2 class="title mb-0">Meet Our Expert will ready for your service</h2>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <div class="team-member style-3">
          <div class="team-images">
            <img class="img-fluid" src="images/team/01.jpg" alt="">
            <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          </div>          
          <div class="team-description">
            <h5><a href="team-single.html">Jesson Mart</a></h5>
            <span>Advisor</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-5 mt-md-0">
        <div class="team-member style-3">
          <div class="team-images">
            <img class="img-fluid" src="images/team/02.jpg" alt="">
            <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          </div>          
          <div class="team-description">
            <h5><a href="team-single.html">Jesson Mart</a></h5>
            <span>Advisor</span>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12 mt-5 mt-md-0">
        <div class="team-member style-3">
          <div class="team-images">
            <img class="img-fluid" src="images/team/03.jpg" alt="">
            <div class="team-social-icon">
            <ul>
              <li><a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-google-plus-g"></i></a>
              </li>
              <li><a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>
          </div>          
          <div class="team-description">
            <h5><a href="team-single.html">Jesson Mart</a></h5>
            <span>Advisor</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--team end-->


<!--blog start-->

<section class="o-hidden pos-r">
  <div class="inside-text">
    <span>Blog</span>
  </div>
  <div class="container">
    <div class="row justify-content-center text-center">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>Blog</h6>
          <h2 class="title">Read Our Latest News</h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4">
        <div class="post style-3">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/04.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We Develop Digital Strategy</h5>
            </div><a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="post style-3">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/05.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>These guide Designing work</h5>
            </div><a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-5 mt-md-0">
        <div class="post style-3">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/06.jpg" alt="">
          </div>
          <div class="post-desc">
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
            <div class="post-title">
              <h5>We're Nominated To Agency</h5>
            </div><a href="blog-single.html"><i class="fas fa-long-arrow-alt-left ml-2"></i> Read More</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog end-->

</div>

<!--body content end--> 
        
    </div>
</template>
<script>
// @ is an alias to /src

export default {
  data: function () {
        return {
            hasBanner: false,
            name: "home",
        }
    }
};
</script>